export default "__VITE_ASSET__CPA8DhD3__"